import React, {useEffect, useState} from "react";
import '../../styles/components/lesson/segment-selector.scss';
import Segment from "../../models/view/lessonPage/Segment";
import ControlBarDropDown from "./ControlBarDropDown";
import ControlBarDropDownMenuItem from "./ControlBarDropDownMenuItem";
import {FontIcon} from "../common/FontIcon";
import {NavigateFunction, useNavigate} from "react-router-dom";
import {useAppSelector} from "../../redux/hooks";
import {lessonPlayerStore} from "../../redux/lesson/LessonPlayerStore";

export default function SegmentSelector() {
  const segments = useAppSelector(lessonPlayerStore.getSegments) ?? [];
  const lesson = useAppSelector(lessonPlayerStore.getLesson);
  const segment = useAppSelector(lessonPlayerStore.getSegment);
  const isSegmentDropdownSelectorOpen = useAppSelector(lessonPlayerStore.getIsSegmentSelectorDropdownOpen);
  const coverArtUrl = lesson?.coverArtUrl ?? '';
  const currentlySelectedSegmentName = lesson?.title ?? '';
  const currentlySelectedSegment = segment || segments[0];

  const navigate = useNavigate();
  const iconElement = createIconElement(coverArtUrl, currentlySelectedSegmentName, isSegmentDropdownSelectorOpen);
  return (
    <ControlBarDropDown
      additionalCssClassName="segment-selector"
      ariaLabel={"Lesson segments"}
      tooltip={"Lesson segments"}
      isDropdownMenuOpen={isSegmentDropdownSelectorOpen}
      changeDropdownMenuOpen={(isOpen: boolean)=> lessonPlayerStore.setIsSegmentSelectorDropdownOpen(isOpen)}
      iconElement={iconElement}>
      {createSegmentSelectorItemEls(segments, (isOpen: boolean) => lessonPlayerStore.setIsSegmentSelectorDropdownOpen(isOpen), currentlySelectedSegment, navigate)}
    </ControlBarDropDown>
  );
}

const SegmentCounterText = ()=> {
  const [isNarrowPortrait, setIsNarrowPortrait] = useState<boolean>(false);
  const segments = useAppSelector(lessonPlayerStore.getSegments) ?? [];
  const segment = useAppSelector(lessonPlayerStore.getSegment);
  const index = segments?.findIndex((s) => s.id === segment?.id && s.mode === segment?.mode) + 1;

  useEffect(() => {
    const mediaWatcher = window.matchMedia("(max-width: 400px) and (orientation: portrait)");
    setIsNarrowPortrait(mediaWatcher.matches);

    function updateIsNarrowScreen(e: any) {
      setIsNarrowPortrait(e.matches);
    }
    mediaWatcher.addEventListener('change', updateIsNarrowScreen)

    return function cleanup() {
      mediaWatcher.removeEventListener('change', updateIsNarrowScreen)
    }
  }, [isNarrowPortrait, setIsNarrowPortrait]);

  if (isNarrowPortrait) {
    return (<span>{index}</span>);
  } else {
    return (<span>{segments.length > 0 ? `${index} of ${segments.length}` : ''}</span>);
  }
}

function createIconElement(coverArtUrl: string, currentlySelectedSegmentName: string, isSegmentDropdownSelectorOpen: boolean){
  const arrowEl = isSegmentDropdownSelectorOpen ? <FontIcon icon={"icon-angle-up"}/> : <FontIcon icon={"icon-angle-down"}/>

  return <div className="label-and-icon">
    <img className="lesson-art" alt={""} src={coverArtUrl} width={40} height={40} />
    <div className="label">
      <div className="segment-name">{currentlySelectedSegmentName}</div>
      <div className="segment-n-of-x"><SegmentCounterText/> {arrowEl}</div>
    </div>
  </div>;
}

function createSegmentSelectorItemEls(segments: Segment[], changeIsDropdownSelectorOpen: (isOpen: boolean) => void, currentlySelectedSegment: Segment, navigate: NavigateFunction){
  return segments.map(s => createSegmentSelectorItemEl(s, changeIsDropdownSelectorOpen, currentlySelectedSegment, navigate));
}

function createSegmentSelectorItemEl(
  {
    tabDisplayText,
    id,
    url,
    name,
    userAccuracyScore,
    hasUserCompletedTheSegment,
    isUserAccuracyScoreGreen,
    mode,
    hasVideo
  }: Segment,
  changeIsDropdownSelectorOpen: (isOpen: boolean) => void,
  currentlySelectedSegment: Segment,
  navigate: NavigateFunction){
  const isSelected = id === currentlySelectedSegment.id && mode === currentlySelectedSegment.mode;
  const isCompletedClassName = hasUserCompletedTheSegment ? `is-completed` : ``;
  const goodJobAccuracyScoreClassName = isUserAccuracyScoreGreen ? `good-job` : ``;
  const shouldAccuracyScoreBeDisplayedClassName = userAccuracyScore === undefined || userAccuracyScore === null || userAccuracyScore === 0  ? `dont-display-accuracy-score` : ``;
  const hundredPercentEmoji = userAccuracyScore && userAccuracyScore >= 100 ? <span>😎</span> : null;
  const rightSideEl = <div className={`accuracy-score ${goodJobAccuracyScoreClassName} ${shouldAccuracyScoreBeDisplayedClassName}`}>{hundredPercentEmoji}{userAccuracyScore}%</div>;
  const videoIconEl = hasVideo ? <FontIcon icon={"icon-video-tutorial-solid"}/> : null;

  function onClick() {
    navigate(url, {replace: true});
    changeIsDropdownSelectorOpen(false);
  }

  return <ControlBarDropDownMenuItem key={`segment_${id}_${mode}`} isSelected={isSelected} onClick={onClick}>
    <div className={`segment-selector-menu-item ${isCompletedClassName}`}>
      <div className="segment-name"><div className="segment-number">{tabDisplayText}</div><div className="name">&nbsp;{name}</div></div>
      <div className="right-side-container">{rightSideEl}{videoIconEl}</div>
    </div>
  </ControlBarDropDownMenuItem>
}
